import { BaseInputModel } from '@/helpers/entities/models/BaseInputModel';
import { EcommerceCategoryModel } from '@/helpers/entities/models/EcommerceCategoryModel';
import { State } from '@/helpers/entities/enums/v2/State';
import { EcommerceProductCategoryModel } from '@/helpers/entities/models/EcommerceProductCategoryModel';
export class EcommerceProductCategoryInputModel extends BaseInputModel {
    constructor(payload = null) {
        super();
        if (payload instanceof EcommerceCategoryModel ||
            payload instanceof EcommerceProductCategoryModel) {
            if (payload instanceof EcommerceProductCategoryModel) {
                this.baseGlobalId = payload.baseGlobalId;
            }
            this.uuid = payload.uuid;
            this.subCategoryUuids = payload.subCategoryUuids;
            this.name = payload.name;
            this.subcategories = payload.subcategories;
            this.markAsFetched();
        }
        else {
            this.init();
        }
    }
    init() {
        this.uuid = null;
        this.subCategoryUuids = [];
        this.state = State.new;
        this.name = null;
        this.subcategories = [];
    }
}
